<div class="py-5 activity-description-bold d-flex justify-content-center align-items-center text-center"
    innerHTML="{{'footerText' | translate: {year: currentYear} }}">
</div>